import React from 'react'
import { GigEndConfirmModalProps } from './types'
import Icon, { IconType } from '@bt-react/components/Icon'
import style from './GigEndConfirmModal.module.scss'
import WarningModal from '../WarningModal'

class GigEndConfirmModal extends React.Component<GigEndConfirmModalProps> {

  componentDidMount () {

    if (!this.props.isLive) {

      this.onCancel()
      return null

    }

  }

  componentDidUpdate (prevProps: GigEndConfirmModalProps) {

    this.toggleModalIfStatusChanges(prevProps)

  }

  toggleModalIfStatusChanges (prevProps: GigEndConfirmModalProps): void {

    if (prevProps.isLive && !this.props.isLive) {

      this.onCancel()

    }

  }

  onConfirm = (): void => this.props.onConfirm()

  onCancel = (): void => this.props.onCancel()

  gigEndModalBody = (
    <div className={style['gig-end__confirm__modal__body']}>
      <p>Proceeding will end this talk for all presenters and viewers. Once ended, a live talk cannot be restored.</p>
      <p><Icon name={IconType.iconName.signOut} /> To leave the presenter screen, close this tab or browser window.</p>
    </div>
  )

  render () {

    return <WarningModal
      headerText='Are you sure you want to end this talk for everyone?'
      body={this.gigEndModalBody}
      confirmationText='End talk for everyone'
      isOpen={this.props.isOpen || false}
      onCancel={this.onCancel}
      onConfirm={this.onConfirm}
    />

  }

}

export default GigEndConfirmModal
